import { useFundAccountPostingsLine } from '../../hooks/useFundAccountPostingsLine';
import type { FundAccountSelection, StatementPeriod } from '../../types/dealerFundStatementPeriod.types';
import { postingsLayoutFor } from '../../utils/postingsLayout';
import type { StatementLine, VatStatementBlock } from '../../utils/statementBlocks';
import { FundAccountPostingsPanel } from './FundAccountPostingsPanel';

interface Props {
    selection: FundAccountSelection;
    period: StatementPeriod;
    todayIso: string;
    periodLabel: string;
    line: StatementLine;
    window: { from: string; to: string };
    currency: string;
    page: number;
    block: VatStatementBlock;
    onPageChange: (page: number) => void;
    onReloadStatement: () => void;
}

export function StatementLinePostings({
    periodLabel,
    currency,
    block,
    onPageChange,
    ...lineArgs
}: Props) {
    const model = useFundAccountPostingsLine({ ...lineArgs, split: block.split, onPageChange });
    return (
        <FundAccountPostingsPanel
            model={model}
            label={lineArgs.line.label}
            periodLabel={periodLabel}
            currency={currency}
            layout={postingsLayoutFor(block.key)}
            onPageChange={onPageChange}
        />
    );
}
